import * as React from 'react';
import * as ReactRouter from 'react-router';
import * as queryString from 'query-string';

import * as routerState from 'login-utils/routerState';
import { getLoginDefaultValues, LoginState, QueryProps } from './LoginForm/loginFormUtils';
import LoginForm from './LoginForm/LoginForm';

class Login extends React.Component<ReactRouter.RouteComponentProps<{}, {}>, LoginState> {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const success = routerState.getOnce('success');
    this.setState({
      successMessage: success,
    });
  }

  render() {
    const { location } = this.props;
    const queryProps = queryString.parse(location.search) as QueryProps;
    const loginDefaultValues = getLoginDefaultValues(queryProps, this.state.successMessage);
    const { successMsg } = loginDefaultValues;
    let { errorMsg } = loginDefaultValues;
    /* istanbul ignore next: (UI-5482) */
    if (queryProps.message === 'timedOut') {
      errorMsg = undefined;
    }
    return (
      <div className="it-Login" id="it-Login">
        <LoginForm errorMsg={errorMsg} successMsg={successMsg} />
      </div>
    );
  }
}

export default Login;
